export const GIFTCARD_HOLD_LOADNG = 'REDUX_SAGA_GIFTCARD_HOLD_LOADNG';
export const GIFTCARD_HOLD_SUCCESS = 'REDUX_SAGA_GIFTCARD_HOLD_SUCCESS';
export const GIFTCARD_HOLD_ERROR = 'REDUX_SAGA_GIFTCARD_HOLD_ERROR';
export const GIFTCARD_HOLD_RESET = 'REDUX_SAGA_GIFTCARD_HOLD_RESET'

export const GIFTCARD_HOLD_DELETE_LOADNG = 'REDUX_SAGA_GIFTCARD_HOLD_DELETE_LOADNG';
export const GIFTCARD_HOLD_DELETE_SUCESS = 'REDUX_SAGA_GIFTCARD_HOLD_DELETE'

export const GIFTCARD_HOLD_RECALCULATE_LOADNG = 'REDUX_SAGA_GIFTCARD_HOLD_RECALCULATE_LOADNG';
export const GIFTCARD_HOLD_RECALCULATE_SUCESS = 'REDUX_SAGA_GIFTCARD_HOLD_RECALCULATE_SUCESS'

export const actionAddGiftCardHold = (dispatch, giftCardNo) => {
    dispatch({ type: GIFTCARD_HOLD_LOADNG, giftCardNo });
};

export const actionResetGiftCardHoldState = (dispatch) => {
    dispatch({ type: GIFTCARD_HOLD_RESET });
}

export const actionDeleteGiftCardHold = (dispatch, GiftcardHoldRef) => {
    dispatch({ type: GIFTCARD_HOLD_DELETE_LOADNG, GiftcardHoldRef });
}

export const actionRecalculateGiftCardHold = (dispatch) => {
    dispatch({ type: GIFTCARD_HOLD_RECALCULATE_LOADNG });
}